import validatorsLibrary from 'validator';
import required from './required';
const validators = {};

class ValidatorRegistry {
  
  static getValidator(name) {

    const validator = validatorsLibrary[name];

    if(validator) {
      return validator;
    }
    return validators[name];
  }

  static addValidator(name, validator) {
    validators[name] = validator;
  }
}

ValidatorRegistry.addValidator('required', required);
export default ValidatorRegistry;